// src/components/Divider/Divider.tsx
import React from 'react';
import './calendar-divider.scss';

interface DividerProps {
  /** Margin above and below the divider */
  spacing?: 'sm' | 'md' | 'lg';
  /** Color variant for the divider */
  variant?: 'light' | 'dark' | 'sky';
  /** Custom height in pixels */
  height?: number;
  /** Custom CSS class */
  className?: string;
}

const GenericDivider = ({
  spacing = 'md',
  variant = 'light',
  height,
  className = '',
}: DividerProps) => {
  const classes = [
    'divider',
    `divider--spacing-${spacing}`,
    `divider--variant-${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style = height ? { height: `${height}px` } : {};

  return <div className={classes} style={style} />;
};

export default GenericDivider;
